<template><div><h1 id="filterpositionen-personen" tabindex="-1"><a class="header-anchor" href="#filterpositionen-personen"><span>Filterpositionen (Personen)</span></a></h1>
<p>Filterpositionen (Personen) — Definiert Filterpositionen</p>
<h2 id="beschreibung" tabindex="-1"><a class="header-anchor" href="#beschreibung"><span>Beschreibung</span></a></h2>
<p>In den Filterpositionen werden die Kriterien (Filterbedingungen) für die Ermittlung der zu selektierenden Personen definiert. Sie entsprechen komplexen SQL-Abfragen, sind aber in einer für den Benutzer verständlichen &quot;Sprache&quot; geschrieben. Zuverlässige Aussagen über das Zusammenwirken einzelner Filterpositionen sind nur mit Erfahrung und genauer Kenntnis der Datenstrukturen zu machen.</p>
<p>Die Informationen / Kriterien in den Filterpositionen sind sehr vielfältig, aus der Praxis gewachsen und können noch weiter angepasst werden. Die einzelnen Filterpositionen sind in diesem Dokument unter folgenden Positionen beschrieben:</p>
<p><RouteLink to="/referenz/refs/ft.refdata.adrfilterpos.html#Filterpositionen-Ueberblick" title="Filterpositionen im Üeberblick">Filterpositionen Ueberblick</RouteLink></p>
<p>Pfad: <code v-pre>Personen → Filter</code></p>
<h2 id="datenfelder" tabindex="-1"><a class="header-anchor" href="#datenfelder"><span>Datenfelder</span></a></h2>
<dl>
<dt>Pos</dt>
<dd>
<p>Positionsnummer der Filterposition. Die Bedingungen der einzelnen Filterpositionen werden in der Reihenfolge der Positionsnummern geprüft. Entsprechend grosse Auswirkungen auf die Laufzeit des Filters müssen beachtet werden.</p>
</dd>
<dt>V</dt>
<dd>
<p>Verknüpfungsbedingung zwischen den Filterpositionen. Mögliche logische Verknüpfungen gemäss Boolscher Mathematik sind:</p>
<table>
<thead>
<tr>
<th>Verknüpfungstyp</th>
<th>Bedeutung</th>
</tr>
</thead>
<tbody>
<tr>
<td>oder</td>
<td>Die Positionszeile wird als &quot;oder&quot; definiert</td>
</tr>
<tr>
<td>und</td>
<td>Die Positionszeile wird als &quot;und&quot; definiert</td>
</tr>
<tr>
<td>nicht</td>
<td>Die Positionszeile wird als &quot;nicht&quot;, bzw. als &quot;und nicht&quot; definiert</td>
</tr>
</tbody>
</table>
</dd>
<dt>(</dt>
<dd>
<p>Klammerung des Ausdrucks:</p>
</dd>
<dd>
<p>&quot;leer&quot; = nicht geklammert</p>
</dd>
<dd>
<p>&quot;(&quot; = öffnende Klammer, mehrfache Verklammerung möglich</p>
</dd>
<dt>Bedingung</dt>
<dd>
<p>Filterbedingung, Auswahl der Bedingungsfelder aus der Wertetabelle. Siehe Details in <a class="link" href="ft.refdata.adrfilterpos.html#Filterpositionen-Ueberblick" title="Filterpositionen im Üeberblick">Filterpositionen im Überblick</a></p>
</dd>
<dt>)</dt>
<dd>
<p>Klammerung des Ausdrucks:</p>
</dd>
<dd>
<p>&quot;leer&quot; = nicht geklammert</p>
</dd>
<dd>
<p>&quot;)&quot; = schliessende Klammer, mehrfache Verklammerung möglich</p>
</dd>
</dl>
<h2 id="filterpositionen-im-ueberblick" tabindex="-1"><a class="header-anchor" href="#filterpositionen-im-ueberblick"><span>Filterpositionen im Üeberblick</span></a></h2>
<p>Legende:</p>
<dl>
<dt>Nr.</dt>
<dd>Nummer der Filterposition</dd>
<dt>Verwendung</dt>
<dd>Verwendung, welcher durch Filterposition ausgewertet werden kann. (A = Adressenstamm, F = Fremdadressen, Z = Zusammenführung mehrerer Filter)</dd>
<dt>Laufzeit</dt>
<dd>
<ul>
<li>= fragt indizierte Felder ab, darum schnell; + = relativ schnell; - = spezielle Position</li>
</ul>
</dd>
<dt>prüft</dt>
<dd>Filterposition bezieht sich auf das genannte Umfeld</dd>
<dt>Erklärung</dt>
<dd>Erklärung der Filterposition</dd>
</dl>
<p>Achtung: Einige Filterpositionen sind nicht bei allen funtrade-Anwendern installiert. Wenn Sie die Fehlermeldung &quot;Filterbedingung mit dieser Nummer nicht vorhanden&quot; erhalten, ist diese bei Ihnen nicht installiert.</p>
<p><strong>Tabelle 41. Filterpositionen</strong></p>
<table>
<thead>
<tr>
<th>Nr.</th>
<th>Verwendung</th>
<th>Laufzeit</th>
<th>prüft</th>
<th>Erklärung</th>
</tr>
</thead>
<tbody>
<tr>
<td>1</td>
<td>A,F</td>
<td>*</td>
<td>Personen-ID: {1} - {2}</td>
<td>Personen-ID liegt im Bereich von {1} bis und mit {2}; werden {1} oder {2} leergelassen, ist die Suche nach unten bzw. oben unbegrenzt</td>
</tr>
<tr>
<td>2</td>
<td>A,F</td>
<td></td>
<td>Inland: ja</td>
<td>Ländercode leer, CH oder LI</td>
</tr>
<tr>
<td>3</td>
<td>A</td>
<td>+</td>
<td>Status Z:{1} S:{2} K:{3} Erste Sprache:{4} oder Sprachcode:{5}</td>
<td>Prüft Status und Sprache bei Person. Enstprechender Status ausgewählt (Z, S oder K) bedeutet, dass die Person diesen Status haben muss. Ein Minuszeichen (-) bedeutet, Person darf diesen Status nicht haben. Leer bedeutet keine Einschränkung, Person kann, muss aber nicht diesen Status haben. Wenn die Person der entsprechenden Statuskombination entspricht, muss zusätzlich die Sprache stimmen, falls Werte eingetragen sind. Sprache kann entweder durch die erste Sprache (z.B. &quot;d&quot; für deutsch), oder als Sprachcode (Sprachkombination z.B. &quot;id&quot;, italienisch, deutsch) eingetragen werden.</td>
</tr>
<tr>
<td>4</td>
<td>A,F,Z</td>
<td>-</td>
<td>Person im Filter: {1} vorhanden</td>
<td>Person, die im Filter {1} vorhanden ist</td>
</tr>
<tr>
<td>5</td>
<td>A,F</td>
<td>-</td>
<td>Person Haushaltsbeziehung im Filter: {1} vorhanden</td>
<td>Prüft, ob eine der beiden Personen mit Haushaltsbeziehung im Filter {1} vorhanden ist</td>
</tr>
<tr>
<td>6</td>
<td>A,F</td>
<td></td>
<td>Anredecode: {1}</td>
<td>Auswahl des Anredecodes</td>
</tr>
<tr>
<td>7</td>
<td>A</td>
<td>*</td>
<td>Person mit Zusage: {1} aus Region: {2}</td>
<td>Person mit einer Zusage {1}, die in der Region {2} vorhanden ist</td>
</tr>
<tr>
<td>8</td>
<td>A,F</td>
<td>*</td>
<td>Postleitzahl: {1} - {2}</td>
<td>Postadresse im Bereich von Postleitzahl {1} bis und mit {2}</td>
</tr>
<tr>
<td>9</td>
<td>A,F</td>
<td></td>
<td>Ort (Namensanfang): {1}</td>
<td>Postadresse in einem Ort, der mit {1} anfängt (eine beliebige Anzahl Buchstaben kann eingegeben werden)</td>
</tr>
<tr>
<td>10</td>
<td>A,F</td>
<td></td>
<td>Geburtsjahr: {1} - {2}</td>
<td>Personen mit Jahrgang von {1} bis und mit {2}</td>
</tr>
<tr>
<td>11</td>
<td>A,F</td>
<td></td>
<td>Geburtsmonat: {1} - {2}</td>
<td>Personen mit Geburtsmonat von {1} bis und mit {2}</td>
</tr>
<tr>
<td>12</td>
<td>A,F</td>
<td></td>
<td>Geburtstag: {1} - {2}</td>
<td>Personen mit Geburtsdatum von {1} bis und mit {2}</td>
</tr>
<tr>
<td>13</td>
<td>A</td>
<td>*</td>
<td>Eintritt Zusage: {1} Datum: {2} - {3}</td>
<td>Personen mit einer aktiven Zusage {1}, die im Datumsbereich von {2} bis und mit {3} erfasst wurde</td>
</tr>
<tr>
<td>14</td>
<td>A</td>
<td>+</td>
<td>Zusage: {1} Austritt (Vergangenheit): {2} - {3}</td>
<td>Person mit einer Ex-Zusage {1}, die im Datumsbereich von {2} bis und mit {3} ausgetreten ist</td>
</tr>
<tr>
<td>15</td>
<td>A,F</td>
<td></td>
<td>Personentyp: {1}</td>
<td>Auswahl des Personentyps</td>
</tr>
<tr>
<td>16</td>
<td>A</td>
<td></td>
<td>Person mit Refusékategorie: {1} Anzahl: {2} - {3} Datum: {4} - {5} Kanal: {6}</td>
<td>Personen mit einer bestimmten Anzahl Refusés einer Kategorie in einem Datumsbrereich, die über den gewählten Kanal eingegangen sind</td>
</tr>
<tr>
<td>18</td>
<td>A</td>
<td></td>
<td>Titelcode (Anfang): {1}</td>
<td>Auswahl des Titels</td>
</tr>
<tr>
<td>19</td>
<td>A,F</td>
<td></td>
<td>Personenname (mit Wildcards * und .): {1}</td>
<td>Person, der die eingegebenen Zeichenfolge im Firmennamen oder Nachnamen entspricht (Stern steht für eine beliebige Anzahl Zeichen, Punkt steht für ein beliebiges Zeichen)</td>
</tr>
<tr>
<td>20</td>
<td>A</td>
<td></td>
<td>Ereignismerkmal: {1} Wert: {2} Datum: {3} - {4}</td>
<td>Personen die irgendein Response-Ereignis haben mit einem bestimmten Ereignismerkmal.</td>
</tr>
<tr>
<td>21</td>
<td>A</td>
<td>*</td>
<td>Personenmerkmal: {1}</td>
<td>Auswahl eines Personenmerkmals</td>
</tr>
<tr>
<td>22</td>
<td>A</td>
<td>*</td>
<td>Ereignis: {1} Typ: {2} Kategorie: {3} Datum: {4} - {5} Kanal: {6}</td>
<td>Person, die das Ereignis {1} mit Typ {2} und Kategorie {3} im Datumsbereich von {4} bis {5} und mit Kanal {6} erhalten hat</td>
</tr>
<tr>
<td>23</td>
<td>A</td>
<td>*</td>
<td>Response-Ereignis: {1} Position: {2} Wert: {3} - {4}</td>
<td>Person mit Response-Ereignis {1}, Position {2} und monetärer Wert von {3} bis und mit {4}</td>
</tr>
<tr>
<td>24</td>
<td>A</td>
<td></td>
<td>Umsatz Beitrag Jahr: {1} - {2} Wert: {3} - {4}</td>
<td>Person mit Umsatz Mitgliederbeitrag in den Jahren von {1} bis und mit {2} mit monetärem Wert von {3} bis und mit {4}</td>
</tr>
<tr>
<td>25</td>
<td>A</td>
<td></td>
<td>Umsatz Spenden Jahr: {1} - {2} Wert: {3} - {4}</td>
<td>Person mit Spendenumsatz in den Jahren von {1} bis und mit {2} mit monetärem Wert von {3} bis und mit {4}</td>
</tr>
<tr>
<td>26</td>
<td>A</td>
<td></td>
<td>Umsatz Warenkauf Jahr: {1} - {2} Wert: {3} - {4}</td>
<td>Person mit Kauf-Umsatz in den Jahren von {1} bis und mit {2} mit monetärem Wert von {3} bis und mit {4}</td>
</tr>
<tr>
<td>27</td>
<td>A</td>
<td></td>
<td>Status Zusage: ja</td>
<td>Person mit einer aktive Zusage</td>
</tr>
<tr>
<td>28</td>
<td>A</td>
<td></td>
<td>Status Spender: ja</td>
<td>Person mit Status S</td>
</tr>
<tr>
<td>29</td>
<td>A</td>
<td></td>
<td>Status Käufer: ja</td>
<td>Person mit Status K</td>
</tr>
<tr>
<td>30</td>
<td>A</td>
<td></td>
<td>Umsatz Typ: {1} Jahr: {2} - {3} Wert: {4} - {5}</td>
<td>Personen, die in den Jahren von {2} bis und mit {3} einen Umsatz des Typs {1} in der Höhe von {4} bis und mit {5} haben</td>
</tr>
<tr>
<td>31</td>
<td>A,F</td>
<td></td>
<td>Kanton: {1}</td>
<td>Postadresse im Kanton {1}</td>
</tr>
<tr>
<td>32</td>
<td>A</td>
<td>+</td>
<td>Erste Sprache: {1}</td>
<td>Person mit erstem Sprachcode {1}</td>
</tr>
<tr>
<td>33</td>
<td>A</td>
<td>+</td>
<td>Ausland: ja</td>
<td>Ländercode nicht CH, LI oder leer</td>
</tr>
<tr>
<td>34</td>
<td>A</td>
<td></td>
<td>Datum der Spende: {1} - {2} Wert der Spende: {3} - {4} (nicht mehr verwenden!!!!!)</td>
<td>Spendeneingang im Zeitraum von {1} bis und mit {2} in der Höhe von {3} bis und mit {4}</td>
</tr>
<tr>
<td>35</td>
<td>A</td>
<td></td>
<td>Landeskennzeichen: {1}</td>
<td>Person mit Landeskennzeichen {1}</td>
</tr>
<tr>
<td>36</td>
<td>A,F</td>
<td></td>
<td>Sprachcode: {1}</td>
<td>Auswahl des Sprachcodes</td>
</tr>
<tr>
<td>37</td>
<td>A</td>
<td></td>
<td>Erfassungsdatum der Person: {1} - {2}</td>
<td>Personen, die im Zeitraum von {1} bis und mit {2} erfasst wurden</td>
</tr>
<tr>
<td>38</td>
<td>A</td>
<td></td>
<td>Personenquelle: {1}</td>
<td>Auswahl der Personenquelle</td>
</tr>
<tr>
<td>39</td>
<td>A</td>
<td>*</td>
<td>Zusage: {1} Typ: {2}</td>
<td>Aktive Zusage {1} und Typ {2}</td>
</tr>
<tr>
<td>40</td>
<td>A</td>
<td></td>
<td>Auftrag mit Bestellart: {1} Datum: {2} - {3}</td>
<td>Prüft, ob eine Person einen Auftrag mit Bestellart {1} im Datumsbereich von {2} bis und mit {2} hat</td>
</tr>
<tr>
<td>41</td>
<td>A</td>
<td>*</td>
<td>Zusage: {1} Publikation: {2}</td>
<td>Person mit einer aktiven Zusage {1} und Publikationscode {2}</td>
</tr>
<tr>
<td>42</td>
<td>A</td>
<td>+</td>
<td>Ex-Zusage: {1} Eintrittsdatum: {2} - {3}</td>
<td>Person mit einer Ex-Zusage {1} mit Eintrittsdatum von {2} bis und mit {3}</td>
</tr>
<tr>
<td>43</td>
<td>A</td>
<td></td>
<td>Lieferant: ja</td>
<td>Prüft, ob es sich bei der Person um einen Lieferanten handelt</td>
</tr>
<tr>
<td>44</td>
<td>A,F</td>
<td></td>
<td>Geschlecht: {1}</td>
<td>Auswahl des Geschlechtscodes</td>
</tr>
<tr>
<td>45</td>
<td>A</td>
<td></td>
<td>Lieferant von Artikel mit Artikelmerkmal: {1}</td>
<td>Lieferantenadresse eines Artikels mit Artikelmerkmal {1} handelt</td>
</tr>
<tr>
<td>46</td>
<td>A</td>
<td></td>
<td>Person ohne Botenbezirk, die einen haben sollte: ja</td>
<td>Person fälschlicherweise ohne Botenbezirk</td>
</tr>
<tr>
<td>47</td>
<td>A</td>
<td>*</td>
<td>Zusage: {1} Fakturadatum: {2} - {3}</td>
<td>Person mit einer aktiven Zusage {1} mit Fakturadatum von {2} bis und mit {3}</td>
</tr>
<tr>
<td>48</td>
<td>A</td>
<td></td>
<td>Mit Zusager in Haushaltsbeziehung: ja</td>
<td>Prüft, ob eine Person in Haushaltsbeziehung mit einer Person steht, die eine aktive Zusage hat</td>
</tr>
<tr>
<td>49</td>
<td>A</td>
<td></td>
<td>Mit Spender in Haushaltsbeziehung: ja</td>
<td>Prüft, ob eine Person in Haushaltsbeziehung mit einer Person steht, die den Status S hat</td>
</tr>
<tr>
<td>50</td>
<td>A</td>
<td></td>
<td>Mit Käufer in Haushaltsbeziehung: ja</td>
<td>Prüft, ob eine Person in Haushaltsbeziehung mit einer Person steht, die den Status K hat</td>
</tr>
<tr>
<td>51</td>
<td>A</td>
<td></td>
<td>Anzahl Spenden: {1} - {2}</td>
<td>Personen mit Anzahl Spenden (nur RSS Ereignisse) lifetime von {1} bis und mit {2}</td>
</tr>
<tr>
<td>52</td>
<td>A</td>
<td></td>
<td>Auftrag mit Artikel: {1} und Verarbeitungsdatum: {2} - {3}</td>
<td>Auftraggeber, der den Artikel {1} bestellt hat und das Feld im Auftrag &quot;verarbeiten ab&quot; im Zeitraum von {2} bis und mit {3} hat</td>
</tr>
<tr>
<td>53</td>
<td>A</td>
<td></td>
<td>Zusage: {1} Akquisitionsereignis: {2} Position: {3} (auch Ex-Zusagen: {4})</td>
<td>Personen mit einer aktiven Zusage {1} mit Akquisitionsereignis {2} Position {3} (wahlweise können Ex-Zusagen mitberücksichtigt werden oder nicht)</td>
</tr>
<tr>
<td>54</td>
<td>A</td>
<td>*</td>
<td>Zusage: {1} bezahlt bis Jahr: {2} (nicht für Vergangenheit)</td>
<td>Personen, die ihre Zusage {1} bis und mit Jahr {2} bezahlt haben</td>
</tr>
<tr>
<td>55</td>
<td>A,F</td>
<td>*</td>
<td>Ereignis mit Typ: {1} Kategorie: {2} Datum: {3} - {4} Kanal: {5}</td>
<td>Ereignis mit Typ: {1} Kategorie: {2} Datum: {3} - {4} Kanal: {5}</td>
</tr>
<tr>
<td>57</td>
<td>A,F</td>
<td>*</td>
<td>Ereignis: {1} Position: {2} - {3} Typ: {4} Kategorie: {5} (ALT, NICHT MEHR VERWENDEN)</td>
<td>Personen mit Ereignis {1} mit Position im Bereich von {2} bis und mit {3} (wahlweise können Typ und Kategorie noch eingeschränkt werden)</td>
</tr>
<tr>
<td>58</td>
<td>A,F</td>
<td>*</td>
<td>Ereignis: {1} Typ: {2} Kategorie: {3}</td>
<td>Personen mit Ereignis {1}, Typ {2} und Kategorie {3}</td>
</tr>
<tr>
<td>59</td>
<td>A</td>
<td>*</td>
<td>Zusage: {1} Zahlungsmodus: {2} mit Kanal: {3} per {4}</td>
<td>Personen mit einer aktive Zusage {1} mit Zahlungsmodus {2} und Kanal {3} die per {4} gültig ist</td>
</tr>
<tr>
<td>60</td>
<td>A</td>
<td>*</td>
<td>Letzter Zusagen-Umsatz: {1} - {2} Sprachcode beginnt mit: {3}</td>
<td>Personen mit letztem Zusagenumsatz in den Jahren von {1} bis und mit {2} und Sprachcode {3}</td>
</tr>
<tr>
<td>61</td>
<td>A</td>
<td>*</td>
<td>Letzte Spende: {1} - {2} Sprachcode beginnt mit: {3}</td>
<td>Personen mit letztem Spendenumsatz in den Jahren von {1} bis und mit {2} und Sprachcode {3}</td>
</tr>
<tr>
<td>62</td>
<td>A</td>
<td>*</td>
<td>Letzter Kauf: {1} - {2} Sprachcode beginnt mit: {3}</td>
<td>Personen mit letztem Kauf-Umsatz in den Jahren von {1} bis und mit {2} und Sprachcode {3}</td>
</tr>
<tr>
<td>65</td>
<td>A</td>
<td></td>
<td>Spenden-Frequenz: {1} % - {2} %</td>
<td>Personen mit einer Spenden-Frequenz von {1} % bis und mit {2} % (z.B. hat eine Person mit 4 Initial-Spendenereignissen und 1 Response-Spendenereignis eine Frequenz von 25%)</td>
</tr>
<tr>
<td>66</td>
<td>A</td>
<td></td>
<td>Kauf-Frequenz: {1} % - {2} %</td>
<td>Personen mit einer Kauf-Frequenz von {1} % und {2} % (z.B. hat eine Person mit 2 Initial-Kaufereignissen und 1 Response-Kaufereignis eine Frequenz von 50%)</td>
</tr>
<tr>
<td>67</td>
<td>A</td>
<td></td>
<td>Zusagensperre vorhanden: ja</td>
<td>Prüft, ob eine Person eine selektive Sperre für den Bereich &quot;Zusagen&quot; hat</td>
</tr>
<tr>
<td>68</td>
<td>A</td>
<td></td>
<td>Spendensperre vorhanden: ja</td>
<td>Prüft, ob eine Person eine selektive Sperre im Bereich &quot;Spenden&quot; hat</td>
</tr>
<tr>
<td>69</td>
<td>A</td>
<td></td>
<td>Kaufsperre vorhanden: ja</td>
<td>Prüft, ob eine Person eine selektive Sperre im Bereich &quot;Kauf&quot; hat</td>
</tr>
<tr>
<td>70</td>
<td>A</td>
<td>*</td>
<td>Zusage: {1} Zahlungsmodus: {2} Anzahl Teilzahlungen: {3} - {4}</td>
<td>Personen mit einer aktiven Zusage {1} mit Zahlungsmodus {2} und Anzahl Raten von {3} bis und mit {4}</td>
</tr>
<tr>
<td>71</td>
<td>A</td>
<td>*</td>
<td>Zusage: {1} Anzahl Widerrufe oder nicht erfolgreichen Belastungen: {2} - {3}</td>
<td>Person mit einer aktiven Zusage {1} und Anzahl Widerrufe oder nicht erfolgreichen Belastungen von {2} bis und mit {3}. Die Anzahl wird jeweils seit der letzten erfolgreichen Belastung gezählt.</td>
</tr>
<tr>
<td>73</td>
<td>A</td>
<td></td>
<td>Ereignis: {1} Typ: {2} Kategorie: {3} (bei Personen in Haushaltsbeziehung)</td>
<td>Prüft, ob die Person, mit der eine Person in Haushaltsbeziehung steht, das Ereignis {1} hat (wahlweise können Typ und Kategorie eingeschränkt werden)</td>
</tr>
<tr>
<td>74</td>
<td>A</td>
<td></td>
<td>Erfasst von Benutzer: {1} Datum: {2} - {3}</td>
<td>Personen, die vom Benutzer {1} im Zeitraum von {2} bis und mit {3} erfasst wurden</td>
</tr>
<tr>
<td>75</td>
<td>A</td>
<td>*</td>
<td>Zusage: {1} mit zukünftigem Zahlungsmodus: {2}</td>
<td>Personen mit aktiver Zusage {1} und zukünftigem Zahlungsmodus {2}</td>
</tr>
<tr>
<td>76</td>
<td>A</td>
<td></td>
<td>Response-Ereignissituation: {1} Anzahl: {2} - {3} Datum: {4} - {5}</td>
<td>Prüft, ob eine Person im Zeitraum von {4} bis und mit {5} genau Anzahl Zahlungen von {2} bis und mit {3} auf das Ereignis {1} hat</td>
</tr>
<tr>
<td>77</td>
<td>A</td>
<td></td>
<td>Auftrag mit Auftragsart: {1} Datum: {2} - {3}</td>
<td>Personen mit einem Auftrag mit Auftragsart {1} im Zeitraum von {2} bis und mit {3}</td>
</tr>
<tr>
<td>78</td>
<td>A</td>
<td></td>
<td>Unerledigter Auftrag mit Auftragsart: {1} vorhanden</td>
<td>Personen mit einem unerledigten Auftrag mit Auftragsart {1}</td>
</tr>
<tr>
<td>79</td>
<td>A</td>
<td></td>
<td>Wert letzten Response: {1} - {2} Umsatztyp: {3}</td>
<td>Prüft, ob der Wert letzten Response mit Umsatztyp {3} im Bereich von {1} bis und mit {2} liegt</td>
</tr>
<tr>
<td>80</td>
<td>A</td>
<td></td>
<td>Person aus Region: {1} von Regionengruppe: {2}</td>
<td>Person aus Region {1} (geografisches Gebiet) von Regionengruppe {2} (Definiert in Tabelle Regionen)</td>
</tr>
<tr>
<td>81</td>
<td>A</td>
<td></td>
<td>Passive Person: ja</td>
<td>Personen, die passiv gesetzt sind</td>
</tr>
<tr>
<td>82</td>
<td>A</td>
<td></td>
<td>Anzahl Käufe: {1} - {2}</td>
<td>Anzahl Käufe lifetime von {1} bis und mit {2}</td>
</tr>
<tr>
<td>83</td>
<td>A</td>
<td>*</td>
<td>Zusage: {1} mit versprochenem Betrag: {2} - {3}</td>
<td>Personen mit einer aktive Zusage {1} mit versprochenem Betrag in der Höhe von {2} bis und mit {3}</td>
</tr>
<tr>
<td>84</td>
<td>A</td>
<td>*</td>
<td>Aktion mit Projektnummer: {1} im Jahr: {2} Aktionscode: {3}</td>
<td>Prüft, ob eine Person eine Aktion mit Projektnummer {1} im Jahr {2} mit Aktionscode {3} hat</td>
</tr>
<tr>
<td>85</td>
<td>A,F</td>
<td></td>
<td>Person ist: {1} - {2} Jahre alt (in: {3} Tagen)</td>
<td>Person ist von {1} bis und mit {2} Jahre alt am Stichtag vor/in {3} Tagen</td>
</tr>
<tr>
<td>86</td>
<td>A</td>
<td></td>
<td>Zusage: {1} muss mit ESR noch Betrag: {2} CHF bezahlen (aktuelles Jahr oder Jahr in: {3} Tagen)</td>
<td>Betrag, die eine Zusage mit ESR jährlich zahlen muss (versprochener oder Standard-Betrag). Bei vorausbezahlten oder von Drittzahlern bezahlten Zusagen und anderen Zahlungsarten als ESR ist es Betrag 0. &quot;Jahr in {3} Tagen&quot;kann man verwenden, wenn man vor dem Jahreswechsel ein Mailing vorbereitet. Z.B. entspricht am 15. Januar &quot;Jahr in -20 Tagen&quot; das Jahr dem Vorjahr.</td>
</tr>
<tr>
<td>87</td>
<td>A</td>
<td></td>
<td>Zusage: {1} mit zu zahlendem ESR Betrag: {2} CHF (aktuelles Jahr oder Jahr in: {3} Tagen)</td>
<td>Betrag, die eine Zusage mit ESR jährlich zahlen muss (versprochener oder Standard-Betrag). Bei oder von Drittzahlern bezahlten Zusagen und anderen Zahlungsarten als ESR ist es Betrag 0. Unterschied zur Position 86 ist nur bei vorausbezahlten Zusagen</td>
</tr>
<tr>
<td>88</td>
<td>A</td>
<td></td>
<td>Zusage: {1} wurde in/nach den/dem letzten: {2} -en Monat fakturiert</td>
<td>Zusage {1} wurde im oder nach dem letzten {2} -en Monat fakturiert (z.B. in oder nach dem letzten 10ten = im oder nach dem letzten Oktober)</td>
</tr>
<tr>
<td>89</td>
<td>A</td>
<td></td>
<td>Zusage: {1} mit bestimmten (nicht offenem) ESR-Betrag, noch nicht bezahlt (aktuelles Jahr oder Jahr in: {2} Tagen)</td>
<td>Prüft ob eine Zusage einen festen, noch nicht bezahlten Betrag zu zahlen hat. &quot;Jahr in {2} Tagen&quot;kann man verwenden, wenn man vor dem Jahreswechsel ein Mailing vorbereitet. Z.B. entspricht am 15. Januar &quot;Jahr in -20 Tagen&quot; das Jahr dem Vorjahr.</td>
</tr>
<tr>
<td>90</td>
<td>A</td>
<td></td>
<td>Zusage: {1} zahlt Drittzahler (aus CH: {2})</td>
<td>Zusage {1} bezahlt durch Drittzahler, wahlweise aus der Schweiz oder nicht</td>
</tr>
<tr>
<td>91</td>
<td>A</td>
<td></td>
<td>Umsatztyp: {1} Wert: {2} {3} Datum: {4} - {5}</td>
<td>Personen mit Umsatz des Umsatztyps {1} mit Wert {2} {3} im Zeitraum von {4} bis und mit {5}</td>
</tr>
<tr>
<td>92</td>
<td>A</td>
<td></td>
<td>Umsatztyp: {1} hat Umsatz: {2} - {3} im Jahr (aktuelles Jahr oder Jahr in: {4} Tagen)</td>
<td>Prüft Umsatzbereich von einem bestimmten Umsatzstyp in aktuellem, oder im Jahr in {4} Tagen. &quot;Jahr in {4} Tagen&quot;kann man verwenden, wenn man vor dem Jahreswechsel ein Mailing vorbereitet. Z.B. entspricht am 15. Januar &quot;Jahr in -20 Tagen&quot; das Jahr dem Vorjahr.</td>
</tr>
<tr>
<td>93</td>
<td>A</td>
<td></td>
<td>Individuell gesetzte Publikation: {1} {2}</td>
<td>Individuell gesetzte Publikation. Es werden nur die manuell gesetzten Publikationen berücksichtigt, automatisch gesetzte Publikationen werden nicht berücksichtigt.</td>
</tr>
<tr>
<td>94</td>
<td>F</td>
<td></td>
<td>Erste zufällige Quelle: {1}</td>
<td>Wenn eine Fremdadresse von mehreren Anbietern (unterschiedliche Quellen) geliefert wird, ermöglicht diese Filterposition eine zufällige Wahl, zu welcher Quelle sie gehört. Somit kann eine gerechtere Verteilung erreicht werden.</td>
</tr>
<tr>
<td>95</td>
<td>A</td>
<td></td>
<td>Zusage: {1} zahlt Drittzahler mit erster Sprache: {2}</td>
<td>Zusage {1}wird von Drittzahler mit erster Sprache {2} bezahlt</td>
</tr>
<tr>
<td>96</td>
<td>A</td>
<td></td>
<td>Anzahl Initial-Ereignis: {1} Ereignissituation: {2} seit letztem Response-Ereignis vor: {3} Jahren</td>
<td>Personen mit {1} Anzahl Initial-Ereignisse der Situation {2} seit dem letzten Response-Ereignis vor {3} Jahren</td>
</tr>
<tr>
<td>97</td>
<td>A</td>
<td></td>
<td>Ist Auftraggeber mit Dauerauftragsart: {1}</td>
<td>Prüft, ob Person ein Auftraggeber in den Daueraufträgen ist</td>
</tr>
<tr>
<td>98</td>
<td>A</td>
<td></td>
<td>Ist Zieladresse mit Dauerauftragsart: {1}</td>
<td>Prüft, ob Person eine Zieladresse (Lieferadresse, Beschenkte) in den Daueraufträgen ist</td>
</tr>
<tr>
<td>99</td>
<td>A</td>
<td></td>
<td>Veranstaltung-Teilnehmer im Jahr: {1} - {2} Typ: {3} Rolle: {4}</td>
<td>Personen, die in den Jahren von {1} bis und mit {2} an einer Veranstaltung mit dem Typ {3} als Rolle {4} teilgenommen haben</td>
</tr>
<tr>
<td>100</td>
<td>F</td>
<td></td>
<td>Fremdadressnummer: {1} - {2}</td>
<td>Fremdadressnummern im Bereich von {1} bis und mit {2}</td>
</tr>
<tr>
<td>101</td>
<td>F</td>
<td>+</td>
<td>Erste Quelle (sortiert nach Alphabet): {1} Sprachcode: {2}</td>
<td>Fremdadressen mit erster Quelle (sortiert nach Alphabet) {1} und Sprachcode {2}</td>
</tr>
<tr>
<td>102</td>
<td>F</td>
<td>+</td>
<td>Quelle der Fremdadresse: {1} Sprachcode: {2}</td>
<td>Fremdadressen mit Quelle {1} (unabhängig davon, ob es die erste Quelle ist oder nicht) mit Sprachcode {2}</td>
</tr>
<tr>
<td>103</td>
<td>A</td>
<td></td>
<td>Person ist Anlass-Ansprechpartner mit Ereignismerkmal: {1} Wert: {2}</td>
<td>Personen die Anlass-Ansprechpartner ist mit einem bestimmten Ereignismerkmal.</td>
</tr>
<tr>
<td>104</td>
<td>A</td>
<td></td>
<td>Branche: {1} enthalten</td>
<td>Personen mit einer Branche, die den Wert {1} enthält (eine beliebige Anzahl Buchstaben kann eingegeben werden)</td>
</tr>
<tr>
<td>105</td>
<td>A</td>
<td></td>
<td>Beruf: {1} enthalten</td>
<td>Personen mit einem Beruf, der den Wert {1} enthält (eine beliebige Anzahl Buchstaben kann eingegeben werden)</td>
</tr>
<tr>
<td>106</td>
<td>A</td>
<td></td>
<td>Zusage: {1} Response-Wert auf Zusage: {2} - {3} Datum: {4} - {5}</td>
<td>Der Response-Wert und der Zeitraum beziehen sich auf die eingegebenen Zusagen.</td>
</tr>
<tr>
<td>107</td>
<td>A</td>
<td></td>
<td>Organisation {1} ({2})</td>
<td>Organisation 'ohne Kontakt/mit einem Kontakt/mit zwei und mehr Kontakten' (Kontakte ohne Personensperre/auch gesperrte Kontakte)</td>
</tr>
<tr>
<td>108</td>
<td>F</td>
<td></td>
<td>Anzahl Quellen: {1} - {2}</td>
<td>Fremdadressen mit Anzahl Quellen von {1} bis und mit {2}</td>
</tr>
<tr>
<td>111</td>
<td>A,F</td>
<td></td>
<td>Quelle: {1}, InfoTyp: {2} und InfoInhalt beinhaltet: {3}</td>
<td>Prüft, ob die Person in Quelle {1} vorgekommen ist, optional (wenn ausgefüllt) mit dem InfoTyp {2} und Inhalt beinhaltet {3} (z.B. Generaldirektor beinhaltet Direktor)</td>
</tr>
<tr>
<td>114</td>
<td>A</td>
<td></td>
<td>Aktion: {1} Anzahl: {2} - {3} Datum: {4} - {5}</td>
<td>Person hat Anzahl der Aktion {1} von {2} bis und mit {3} im Zeitraum von {4} bis und mit {5}</td>
</tr>
<tr>
<td>115</td>
<td>A</td>
<td></td>
<td>Person in Haushaltsbeziehung im Segment: {1} der Segmentierung: {2}</td>
<td>Person mit Haushaltsbeziehung ist im Segment {1} der Segmentierung {2} vorhanden</td>
</tr>
<tr>
<td>116</td>
<td>A</td>
<td></td>
<td>Anzahl Refusés mind.: {1} Bereich: {2} Kat.: {3}, seit letztem Response (nur die letzten: {4} Tage prüfen)</td>
<td>Personen mit einer Mindestanzahl Refusés {1} im Bereich {2} von Kategorie {3} seit dem letzten Response, oder nur durch die Zeitperiode beschränkt, falls kein Response vorhanden ist. Gültige Responses sind nur mit der Situation Spende, Zusage, Verkauf oder Veranstaltung (RSS,RSB,RWV,VER). Die Zeitperiode kann auf die letzten {4} Tage eingeschränkt werden.</td>
</tr>
<tr>
<td>117</td>
<td>A</td>
<td></td>
<td>Zusage: {1} mit Akquisitionstyp Direct Dialog (auch Ex-Zusagen: {2})</td>
<td>Adressen mit einer aktiven Zusage {1} mit Akquisitionstyp &quot;Direct Dialog&quot; (wahlweise können Ex-Zusagen mitberücksichtigt werden oder nicht)</td>
</tr>
<tr>
<td>118</td>
<td>A</td>
<td></td>
<td>Kauf Artikel mit Productmanager: {1} Datum: {2} - {3}</td>
<td>Personen, die im Zeitraum von {2} bis und mit {3} einen Artikel mit Prductmanager {1} gekauft haben</td>
</tr>
<tr>
<td>119</td>
<td>A</td>
<td></td>
<td>Response-Ereignis mit Umsatztyp: {1}, Datum: {2} - {3}, Wert: {4} - {5}</td>
<td></td>
</tr>
<tr>
<td>120</td>
<td>A</td>
<td></td>
<td>Organisatorische Einheit: {1}</td>
<td></td>
</tr>
<tr>
<td>121</td>
<td>A</td>
<td></td>
<td>Adresstyp: {1} Erfassungsdatum: {2} - {3} nur Standard: {4}</td>
<td></td>
</tr>
<tr>
<td>122</td>
<td>A</td>
<td></td>
<td>Adresstyp: {1} Mutationsdatum: {2} - {3} nur Standard: {4}</td>
<td></td>
</tr>
<tr>
<td>123</td>
<td>A</td>
<td></td>
<td>Extra-Publikation: - *</td>
<td>Filtert alle Personen die mit der Funktion 'Ausschluss aller Publikationen' versehen wurden.</td>
</tr>
<tr>
<td>124</td>
<td>A</td>
<td></td>
<td>Zahlung auf Konto: {1} Datum: {2} - {3} Wert: {4} - {5}</td>
<td></td>
</tr>
<tr>
<td>125</td>
<td>A</td>
<td></td>
<td>Person postalisch unvollständig: ja</td>
<td>Person postalisch unvollständig: ja</td>
</tr>
<tr>
<td>126</td>
<td>F</td>
<td></td>
<td>Fremdadresse, übernommen als eigene Person</td>
<td>Fremdadresse, übernommen als eigene Person</td>
</tr>
<tr>
<td>127</td>
<td>A</td>
<td></td>
<td>Status Teilnehmer: ja</td>
<td>Personen mit Status T</td>
</tr>
<tr>
<td>128</td>
<td>A,F</td>
<td></td>
<td>Ereignis: {1} Position: {2} Typ: {3} Kat: {4} ist ältestes Ereignis</td>
<td>Person, die das Ereignis {1} Position {2} mit Typ {3} und Kategorie {4} ältestes Ereignis ist</td>
</tr>
<tr>
<td>129</td>
<td>A</td>
<td></td>
<td>Das älteste Ereignis befindet sich im Zeitraum: {1} - {2}</td>
<td></td>
</tr>
<tr>
<td>130</td>
<td>A</td>
<td></td>
<td>Das älteste Ereignis hat Umsatztyp: {1} mit Wert: {2} - {3}</td>
<td></td>
</tr>
<tr>
<td>131</td>
<td>A</td>
<td></td>
<td>Personenstatus {1} ist {2}</td>
<td></td>
</tr>
<tr>
<td>132</td>
<td>A</td>
<td></td>
<td>Geburtstag heute: ja</td>
<td></td>
</tr>
<tr>
<td>133</td>
<td>A</td>
<td></td>
<td>Spenderstatus {1} per {2}</td>
<td></td>
</tr>
<tr>
<td>134</td>
<td>A</td>
<td></td>
<td>Käuferstatus {1} per {2}</td>
<td></td>
</tr>
<tr>
<td>135</td>
<td>A</td>
<td></td>
<td>Anzahl Refusé-Ereignisse ab {1}, Situation {2}, Kat. {3}, Kanal {4}, Datum {5}-{6}</td>
<td>Anzahl Refusé-Ereignisse ab {1}, Situation {2}, Kat. {3}, Kanal {4}, Datum {5}-{6}</td>
</tr>
<tr>
<td>136</td>
<td>A</td>
<td></td>
<td>Anzahl Refusés {1}-{2}, Situation {3}, Kat. {4}, Kanal {5}, nach letztem Response (letzte {6} Tage prüfen)</td>
<td>Anzahl Refusés {1}-{2}, Situation {3}, Kat. {4}, Kanal {5}, nach letztem Response (letzte {6} Tage prüfen)</td>
</tr>
<tr>
<td>137</td>
<td>A</td>
<td></td>
<td>Standardadresse mit Adresssperre und Kanal {1}, Alternativadresse ohne Sperre vorhanden</td>
<td>Standardadresse mit Adresssperre und Kanal {1}, Alternativadresse ohne Sperre vorhanden</td>
</tr>
<tr>
<td>138</td>
<td>A</td>
<td></td>
<td>Gesamtumsatz (Summe Organisation inkl. Kontakte) Typ: {1} Jahr: {2} - {3} Wert: {4} - {5}</td>
<td>Organisationen inkl. Kontakte, die in den Jahren von {2} bis und mit {3} einen Umsatz des Typs {1} in der Höhe von {4} bis und mit {5} haben</td>
</tr>
<tr>
<td>139</td>
<td>A</td>
<td></td>
<td>Sperre auf Ebene {1}, Kanal {2}, per {3} (abgeleitete Sperren aus höherer Ebene werden nicht berücksichtigt)</td>
<td>Sperre auf Ebene {1}, Kanal {2}, zum Stichdatum {3} (abgeleitete Sperren aus höherer Ebene werden nicht berücksichtigt)</td>
</tr>
<tr>
<td>140</td>
<td>A</td>
<td>*</td>
<td>Aufgabe: {1} Status: {2} Datum: {3} - {4}</td>
<td>Aufgabe: {1} Status: {2} Datum: {3} - {4}</td>
</tr>
<tr>
<td>141</td>
<td>A</td>
<td>*</td>
<td>Kontakt einer Organisation mit Umsatz, Umsatztyp: {1} Wert: {2} - {3} Datum: {4} - {5}</td>
<td>Person ist Kontakt einer Organisation mit Ornaisationsumsatz mit Umsatztyps {1} mit Wert von {2} bis {3} im Zeitraum von {4} bis und mit {5}</td>
</tr>
<tr>
<td>142</td>
<td>A,F</td>
<td></td>
<td>Ereignis: {1} ist {2} Ereignis vom Ereignistyp: {3} und Umsatztyp: {4}</td>
<td>Ereignis: {1} ist {2} Ereignis vom Ereignistyp: {3} und Umsatztyp: {4}</td>
</tr>
<tr>
<td>143</td>
<td>A,F</td>
<td></td>
<td>Aktuelle Standard-{1} hat mindestens {2} Refüsee-Ereignisse Kategorien: {3}</td>
<td>Aktuelle Standard-{1} hat mindestens {2} Refüsee-Ereignisse Kategorien: {3}</td>
</tr>
<tr>
<td>144</td>
<td>A</td>
<td></td>
<td>Person hat Mutationsschutz</td>
<td>Person hat Mutationsschutz (irgend ein Schutz vorhanden ist)</td>
</tr>
<tr>
<td>145</td>
<td>A</td>
<td>*</td>
<td>Spende/Zusagenbeitrag auf Konto: {1}, Kostenstelle: {2}, Datum: {3} - {4}, Wert: {5} - {6}</td>
<td>Spende- oder Zusagenbeitrag mit einem bestimmten Konto oder Kostenstelle, zusätzliche Einschränkung nach Datum und Betrag.</td>
</tr>
<tr>
<td>146</td>
<td>A</td>
<td>*</td>
<td>Personenmerkmal: {1} mit Wertbereich: {2} - {3} gültig innerhalb: {4} - {5}</td>
<td>Personenmerkmal {1}, optional (wenn ausgefüllt) mit dem Wertbereich {2} - {3}, welches irgendwann, zumindest ein Tag, in angegebenem Zeitraum {4} - {5} gültig war</td>
</tr>
<tr>
<td>147</td>
<td>A</td>
<td></td>
<td>Kontakt einer Organisation mit Merkmal: {1} Wert: {2}</td>
<td>Kontakt einer Organisation mit Merkmal: {1} Wert: {2}</td>
</tr>
<tr>
<td>148</td>
<td>A</td>
<td></td>
<td>Teilnehmende Veranstaltung: {1} {2}, Status: {3}</td>
<td>Personen, die an einer Veranstaltung {1} {2} mit Status {3} teilgenommen haben</td>
</tr>
<tr>
<td>157</td>
<td>A,F</td>
<td>*</td>
<td>Ereignis: {1} Position: {2} Typ: {3} Kategorie: {4} Datum: {5} - {6}</td>
<td>Personen mit Ereignis {1}, Position {2}, Typ {3}, Kategorie {4} und Datum im Bereich von {5} bis {6}</td>
</tr>
<tr>
<td>200</td>
<td>A</td>
<td></td>
<td>Aktion: {1} Datum: ({2} - {3}) N ({4} O {5} O {6})</td>
<td>Aktionscode {1} im Datumsbereich, aber gleichzeitig keine der Aktionen {4}, {5}, {6} mit gleicher Sammelnummer vorhanden</td>
</tr>
<tr>
<td>201</td>
<td>A</td>
<td></td>
<td>Person ist temporär gesperrt von: {1} - {2}</td>
<td>Person ist temporär gesperrt von {1} bis und mit {2}</td>
</tr>
<tr>
<td>202</td>
<td>A</td>
<td></td>
<td>Keine Änderung der Zusage: {1} von: {2} - {3}</td>
<td>An der Zusage {1} wurde von {2} bis und mit {3} nichts geändert</td>
</tr>
<tr>
<td>203</td>
<td>A</td>
<td></td>
<td>Eintritt Zusage: {1} in aktuellem, oder max.: {2} Jahren zurückliegendem Jahr (relativ zum Jahr in: {3} Tagen)</td>
<td>Eine aktive Zusage {1} mit Eintrittsdatum in gleichem, oder maximal {2} Jahre zurückliegendem Jahr</td>
</tr>
<tr>
<td>204</td>
<td>A</td>
<td></td>
<td>Publikation: {1} Kanal: {2}</td>
<td>Personen mit Publikation. Es werden sowohl manuell gesetzte als auch automatisch vergebene Publikationen berücksichtigt.</td>
</tr>
<tr>
<td>205</td>
<td>A</td>
<td></td>
<td>Refusé-Ereignis mit Kategorie: {1} Anzahl: {2} - {3} Datum: {4} - {5}</td>
<td>Personen, die eine Anzahl Refusé-Ereignis(se) von {2} bis und mit {3} der Katgeorie {1} im Zeitraum von {4} bis und mit {5} erhalten haben</td>
</tr>
<tr>
<td>206</td>
<td>A,F</td>
<td></td>
<td>Anzahl Initial-Ereignis: {1} - {2} Umsatztyp: {3} Datum: {4} - {5}</td>
<td>Personen, die eine Anzahl Initial-Ereignisse von {1} bis und mit {2} und Umsatztyp {3} im Zeitraum von {4} bis {5} erhalten haben</td>
</tr>
<tr>
<td>207</td>
<td>A</td>
<td></td>
<td>Anzahl Response-Ereignis: {1} - {2} Umsatztyp: {3} Datum: {4} - {5}</td>
<td>Personen, die eine Anzahl Response-Ereignisse von {1} bis und mit {2} und Umsatztyp {3} im Zeitraum von {4} bis {5} erhalten haben</td>
</tr>
<tr>
<td>208</td>
<td>A</td>
<td></td>
<td>Status Individualmarketing: ja</td>
<td>Personen mit Status I</td>
</tr>
<tr>
<td>209</td>
<td>A</td>
<td></td>
<td>Adresstyp: {1} Wert: {2} nur Standard: {3}</td>
<td>Personen mit einem Telekommunikationseintrag des Typs {1} mit Wert {2} (wahlweise kann nur der Standardeintrag selektioniert werden oder alle). Wert gleich leer bedeutet alle, d.h. die Person muss irgendein Eintrag mit dem definierten Adresstyp haben.</td>
</tr>
<tr>
<td>210</td>
<td>A</td>
<td></td>
<td>Hat Kommunikations-Kanal: {1} mit Anzahl Refusés: {2} - {3} (nur Standardadresse)</td>
<td>Personen, die auf dem Kommunikations-Kanal {1} Anzahl {2} bis und mit {3} Refusés erhalten haben. Anzahl Refusés gleich leer bedeutet alle, d.h. von beliebig viele bzw. bis beliebig viele. Die Anzahl Refusés beziehen sich nur auf die aktuelle Standardadresse.</td>
</tr>
<tr>
<td>211</td>
<td>A</td>
<td></td>
<td>Korrespondenz: {1} Datum: {2} - {3}</td>
<td>Personen, bei denen im Zeitraum von {2} bis {3} die Korrespondenz {1} erfasst wurde</td>
</tr>
<tr>
<td>212</td>
<td>A,F</td>
<td></td>
<td>Zufallsauswahl mit: {1} Promille Wahrscheinlichkeit</td>
<td>Selektiert Personen mit einer Zufallsauswahl von {1} Promille Wahrscheinlichkeit</td>
</tr>
<tr>
<td>213</td>
<td>A,F</td>
<td>*</td>
<td>Person ist im Segment: {1} der Segmentierung: {2}</td>
<td>Personen, die im Segment {1} der Segmentierung {2} enthalten sind</td>
</tr>
<tr>
<td>214</td>
<td>A</td>
<td></td>
<td>Personenmerkmal: {1} Wert: {2} exakt</td>
<td>Personen mit dem Personenmerkmal {1}, das exakt den Wert {2} hat</td>
</tr>
<tr>
<td>215</td>
<td>A</td>
<td></td>
<td>Personenmerkmal: {1} Wert: {2} enthalten</td>
<td>Personen mit dem Personenmerkmal {1}, das den Wert {2} enthält</td>
</tr>
<tr>
<td>216</td>
<td>A</td>
<td></td>
<td>Mutiert vom Benutzer: {1} Datum: {2} - {3}</td>
<td>Personen, die vom Benutzer {1} im Zeitraum von {2} bis und mit {3} geändert wurden</td>
</tr>
<tr>
<td>217</td>
<td>A</td>
<td></td>
<td>Avisierung: {1} Datum: {2} - {3}</td>
<td>Personen, die im Zeitraum von {2} bis und mit {3} eine Avisierung erhalten haben oder nicht</td>
</tr>
<tr>
<td>218</td>
<td>A</td>
<td></td>
<td>Kauf mit Konto: {1} Datum: {2} - {3}</td>
<td>Personen, die im Zeitraum von {2} bis und mit {3} einen Artikel mit Konto {1} gekauft haben</td>
</tr>
<tr>
<td>219</td>
<td>A</td>
<td></td>
<td>Kauf mit Kostenstelle: {1} Datum: {2} - {3}</td>
<td>Personen, die im Zeitraum von {2} bis und mit {3} einen Artikel mit Kostenstelle {1} gekauft haben</td>
</tr>
<tr>
<td>220</td>
<td>A</td>
<td></td>
<td>Kauf Artikel mit Medium: {1} Datum: {2} - {3}</td>
<td>Personen, die im Zeitraum von {2} bis {3} einen Artikel mit dem Medium {1} gekauft haben</td>
</tr>
<tr>
<td>221</td>
<td>A</td>
<td></td>
<td>Kauf Artikel mit Artikelgruppe: {1} Datum: {2} - {3}</td>
<td>Personen, die im Zeitraum von {2} bis und mit {3} einen Artikel mit Artikelgruppe {1} gekauft haben</td>
</tr>
<tr>
<td>222</td>
<td>A</td>
<td></td>
<td>Funktion: {1}</td>
<td>Auswahl der Funktion</td>
</tr>
<tr>
<td>223</td>
<td>A</td>
<td></td>
<td>Zusage: {1} mit Zahlungsmodus ESR mutiert auf Zahlungsmodus: {2} im Zeitraum: {3} - {4}</td>
<td>Personen mit einer aktiven Zusage {1}, die auf Zahlungsmodus {2} geändert wurden, im Zeitraum von {3} bis {4}</td>
</tr>
<tr>
<td>224</td>
<td>A</td>
<td>*</td>
<td>Personenmerkmal: {1} Wert: {2} gültig irgendwann von: {3} - {4}</td>
<td>Personenmerkmal {1}, optional (wenn ausgefüllt) mit dem Wert {2}, welches irgendwann, zumindest ein Tag, in angegebenem Zeitraum gültig war</td>
</tr>
<tr>
<td>225</td>
<td>A</td>
<td></td>
<td>Status Zusager vom: {1} - {2}</td>
<td>Personen, die im Zeitraum von {1} bis und mit {2} den Status Z hatten</td>
</tr>
<tr>
<td>226</td>
<td>A</td>
<td></td>
<td>Status Spender vom: {1} - {2}</td>
<td>Personen, die im Zeitraum von {1} bis und mit {2} den Status S hatten</td>
</tr>
<tr>
<td>227</td>
<td>A</td>
<td></td>
<td>Status Käufer vom: {1} - {2}</td>
<td>Personen, die im Zeitraum von {1} bis und mit {2} den Status K hatten</td>
</tr>
<tr>
<td>228</td>
<td>A</td>
<td></td>
<td>RFM, Datum: {1} Achse: {2} Typ: {3} Punkte: {4} - {5}</td>
<td>Prüft, ob Person per Datum in bestimmten Punktebereich liegt</td>
</tr>
<tr>
<td>229</td>
<td>A</td>
<td></td>
<td>Wert: {1} - {2} Umsatztyp: {3} Datum: {4} - {5}</td>
<td>Personen, die im Zeitraum von {4} bis und mit {5} einen Umsatz des Typs {3} in der Höhe von {1} bis und mit {2} hatten</td>
</tr>
<tr>
<td>230</td>
<td>A</td>
<td>*</td>
<td>Beziehung: {1} Richtung: {2} zu Person: {3} per {4}</td>
<td>Person mit einer Beziehung: {1} und Richtung: {2} zu einer anderen Person: {3} per Datum</td>
</tr>
<tr>
<td>231</td>
<td>A,F</td>
<td></td>
<td>Anzahl Ereignisse: {1} - {2} Situation: {3} Typ: {4} Datum: {5} - {6}</td>
<td>Personen, die eine Anzahl Ereignisse von {1} bis und mit {2} mit Situation {3} und Typ {4} im Zeitraum von {5} bis und mit {6} erhalten haben</td>
</tr>
<tr>
<td>232</td>
<td>A</td>
<td></td>
<td>Austritt der Zusage: {1} Datum: {2} - {3} Austrittsereignis: {4} Position: {5}</td>
<td>Austritt der Zusage {1} im Zeitraum von {2} bis und mit {3} mit Austrittsereignis {4} Position {5}</td>
</tr>
<tr>
<td>233</td>
<td>A</td>
<td></td>
<td>Kaufspende Wert: {1} - {2} Datum: {3} - {4}</td>
<td>Personen, die im Zeitraum von {3} bis und mit {4} eine Kaufspende in der Höhe von {1} bis und mit {2} getätigt haben</td>
</tr>
<tr>
<td>234</td>
<td>A</td>
<td></td>
<td>Ausschliesslich Kaufspende Datum: {1} - {2}</td>
<td>Personen, die im Zeitraum von {1} bis und mit {2} ausschliesslich Kaufspenden getätigt haben</td>
</tr>
<tr>
<td>235</td>
<td>A</td>
<td></td>
<td>Zusage: {1} Typ: {2} Alter: {3} - {4} und Mitglied einer Gruppe</td>
<td>Person hat eine aktive Zusage {1} mit Typ {2}, Adressat ist im Alter von {3} bis {4} und Mitglied einer Gruppe (z.B. Familie)</td>
</tr>
<tr>
<td>236</td>
<td>A</td>
<td></td>
<td>Anlassspende mit Anlassart: {1} Datum: {2} - {3}</td>
<td>Personen, die im Zeitraum von {2} bis und mit {3} eine Anlassspende der Anlassart {1} getätigt haben</td>
</tr>
<tr>
<td>237</td>
<td>A</td>
<td>*</td>
<td>Ansprechpersonen mit Anlassart: {1} Datum: {2} - {3} Responsewert: {4} - {5}</td>
<td>Personen, die Ansprechpersonen für die Anlassspenden der Anlassart {1} im Zeitraum von {2} bis und mit {3} und Responsewert: {4} - {5} waren</td>
</tr>
<tr>
<td>238</td>
<td>A</td>
<td></td>
<td>Zusage: {1} mit Zusagetyp: {2}, nur Vorstand: {3} per {4}</td>
<td>Person mit Zusage {1} und Zusagetyp {2}, optional nur Vorstand oder beliebiges Mitglied der Gruppe</td>
</tr>
<tr>
<td>239</td>
<td>A</td>
<td></td>
<td>Zahlungsverbindung: {1}</td>
<td>Auswahl der Zahlungsverbindung</td>
</tr>
<tr>
<td>240</td>
<td>A</td>
<td></td>
<td>Aktive Zusage: {1} Eintritt vor mindestens: {2} Tagen</td>
<td>Personen mit einer aktiven Zusage {1}, die vor mindestens {2} Tagen eingetreten sind</td>
</tr>
<tr>
<td>241</td>
<td>A</td>
<td></td>
<td>Drittzahler für Zusage: {1} Datum: {2} - {3}</td>
<td>Drittzahler für einen Beschenkten mit Zusage {1} an mindestens einem Tag im Datumsbereich. Kann heute bereits eine inaktive Zusage sein.</td>
</tr>
<tr>
<td>242</td>
<td>A</td>
<td></td>
<td>Beziehung(Haushalt)-Umsatz, Umsatztyp: {1} Wert: {2} - {3} Datum: {4} - {5}</td>
<td>Personen mit Beziehung-Umsatz des Umsatztyps {1} mit Wert von {2} bis {3} im Zeitraum von {4} bis und mit {5}</td>
</tr>
<tr>
<td>243</td>
<td>A</td>
<td></td>
<td>Drittzahler hat Beschenkte mit Zusage: {1} mit Typ: {2} per {3} Alter: {4} - {5}</td>
<td>Drittzahler hat Beschenkte mit Zusage: {1} mit Typ: {2} per {3} Alter: {4} - {5}</td>
</tr>
<tr>
<td>244</td>
<td>A</td>
<td></td>
<td>Zusage: {1} bezahlt durch Drittzahler mit eigener Zusage: {2} mit bezahlt bis Jahr: {3}</td>
<td>Beschenkter mit Zusage {1}, hat Drittzahler mit eigener Zusage {2} mit bezahlt bis {3}</td>
</tr>
<tr>
<td>245</td>
<td>A</td>
<td></td>
<td>Zusage: {1} bezahlt durch Drittzahler mit Status Z:{2} S:{3} K:{4}</td>
<td>Beschenkter mit Zusage {1}, hat Drittzahler mit Status Z:{2} S:{3} K:{4}</td>
</tr>
<tr>
<td>246</td>
<td>A</td>
<td></td>
<td>Ist Drittzahler und hat {1} - {2} Beschenkte mit Zusage: {3}</td>
<td>Drittzahler, hat Anzahl von {1} bis {2} Beschenkte mit Zusage {3}</td>
</tr>
<tr>
<td>247</td>
<td>A</td>
<td></td>
<td>Ist Drittzahler mit Drittzahlerumsatz (ohne eigener Umsatz) Umsatz Typ: {1} Jahr: {2} - {3} Wert: {4} - {5}</td>
<td>Ist Drittzahler mit Drittzahlerumsatz (ohne eigener Umsatz) Umsatz Typ: {1} Jahr: {2} - {3} Wert: {4} - {5}</td>
</tr>
<tr>
<td>248</td>
<td>A</td>
<td></td>
<td>Ist Drittzahler mit eigenem Umsatz (ohne Drittzahlerumsatz) Umsatz Typ: {1} Jahr: {2} - {3} Wert: {4} - {5}</td>
<td>Ist Drittzahler mit eigenem Umsatz (ohne Drittzahlerumsatz) Umsatz Typ: {1} Jahr: {2} - {3} Wert: {4} - {5}</td>
</tr>
<tr>
<td>249</td>
<td>A</td>
<td></td>
<td>Beschenkte mit Zusage: {1} und Drittzahler-Ereignis: {2} Position: {3} Typ: {4} im Zeitraum: {5}-{6}</td>
<td>Beschenkte mit Zusage: {1} und Drittzahler-Ereignis: {2} Position: {3} Typ: {4} im Zeitraum: {5}-{6}</td>
</tr>
<tr>
<td>250</td>
<td>A</td>
<td></td>
<td>Aktionsmerkmal: {1} Wert: {2} Datum: {3} - {4}</td>
<td>Personen mit einer Aktion, die ein bestimmtes Aktionsmerkmal enthalten</td>
</tr>
<tr>
<td>251</td>
<td>A</td>
<td></td>
<td>Publikation {1} mit Anzahl von {2} - {3}</td>
<td>Publikation {1} mit Anzahl von {2} - {3}</td>
</tr>
<tr>
<td>252</td>
<td>A</td>
<td></td>
<td>Anlass-Ansprechpersonen mit Anlass-Responsewert: {1} - {2} im Zeitraum: {3} - {4}</td>
<td>Anlass-Ansprechpersonen mit Anlass-Responsewert: {1} - {2} im Zeitraum: {3} - {4}</td>
</tr>
<tr>
<td>253</td>
<td>A</td>
<td></td>
<td>Noch nicht fakturierte Zusage {1} mit rollender Fakturierung, innerhalb der letzten {2} Tage fällig geworden</td>
<td>Die Person hat eine aktive Zusage {1} mit rollender Fakturierung. Monat/Tag des Eintrittsdatums (oder Datum &quot;belasten ab&quot;) liegen maximal {2} Tage zurück.</td>
</tr>
<tr>
<td>254</td>
<td>A</td>
<td></td>
<td>Zusage {1} mit rollender Fakturierung</td>
<td>Die Person hat eine aktive Zusage {1} mit rollender Fakturierung.</td>
</tr>
<tr>
<td>255</td>
<td>A</td>
<td></td>
<td>Zusage {1} mit rollender fakturierung, letzmals fakturiert vor mehr als {2} Tagen</td>
<td>Die Person hat eine aktive Zusage {1} mit rollender Fakturierung, die mehr als {2} Tage zurück liegt (eingeschränkt auf 430 Tage).</td>
</tr>
<tr>
<td>256</td>
<td>A</td>
<td></td>
<td>Zusage {1} mit rollender Fakturierung, letztmals gemahnt vor mehr als {2} Tagen, Anzahl Mahnungen mindestens {3}</td>
<td>Die Person hat eine Zusage {1} mit rollender Fakturierung, die seit der letzten Fakturierung, mindestens {3} Mahnungen erhalten hat. Die letzte Mahnung liegt mindestens {2} Tage zurück (eingeschränkt auf 430 Tage).</td>
</tr>
<tr>
<td>500</td>
<td>S</td>
<td></td>
<td>Zufallsauswahl von {1} Personen</td>
<td>Selektiert werden X Personen nach dem Zufall</td>
</tr>
<tr>
<td>501</td>
<td>S</td>
<td></td>
<td>Anzahl Personen: {1} mit höchstem Umsatz, Umsatztyp(en): {2} im Jahr: {3} - {4}</td>
<td>Selektiert werden die ersten N Personen mit dem höchsten Umsatz für die eingetragenen Umsatztypen und im bestimmten Jahresbereich.</td>
</tr>
</tbody>
</table>
<h2 id="siehe-auch" tabindex="-1"><a class="header-anchor" href="#siehe-auch"><span>Siehe auch</span></a></h2>
<p><RouteLink to="/referenz/refs/ft.refdata.adrfilter.html#Filter" title="Beschreibung">Filter erfassen, ändern</RouteLink> , <RouteLink to="/referenz/refs/ft.refdata.adrfilter.html" title="Personenfilter Kopf">Adressfilter</RouteLink> , <RouteLink to="/referenz/refs/ft.refproc.adrfiltverk.html" title="Filter verknüpfen">Filter verknüpfen</RouteLink> , <RouteLink to="/referenz/refs/ft.refproc.adrmarkauf.html" title="Filtermarkierung aufheben">Adressmarkierungen aufheben</RouteLink></p>
</div></template>


